const at = (o, ...keys) => {
    for (const k of keys) {
        const v = Number(o?.[k]);
        if (Number.isFinite(v) && v > 0)
            return v;
    }
    return 0;
};
/** ادغام لیستی با کلید و مهرِ زمان. سنگ‌قبر حذف می‌کند. */
function mergeList(local, incoming, key, stamp, { tombstones = true } = {}) {
    if (!Array.isArray(incoming) || incoming.length === 0)
        return local;
    const byKey = new Map(local.map((x) => [key(x), x]));
    for (const inc of incoming) {
        if (!inc)
            continue;
        const k = key(inc);
        if (tombstones && inc.deletedAt) {
            byKey.delete(k);
            continue;
        }
        const cur = byKey.get(k);
        if (!cur || stamp(inc) >= stamp(cur))
            byKey.set(k, inc);
    }
    return [...byKey.values()];
}
export function applyChanges(state, changes) {
    if (!changes || Object.keys(changes).length === 0)
        return state;
    const out = { ...state };
    if (changes.settings) {
        const inc = changes.settings;
        if (at(inc, "updatedAt") >= at(state.settings, "updatedAt")) {
            out.settings = { ...state.settings, ...inc };
        }
    }
    if (changes.progress) {
        const inc = changes.progress;
        if (at(inc, "updatedAt") >= at(state.progress, "updatedAt")) {
            out.progress = {
                ...state.progress,
                ...inc,
                // بلندترین زنجیره هرگز کوتاه نمی‌شود؛ سطح اتاق از همین می‌آید
                longestStreak: Math.max(state.progress.longestStreak ?? 0, Number(inc.longestStreak) || 0),
            };
        }
    }
    out.habits = mergeList(state.habits, changes.habits, (x) => x.id, (x) => at(x, "updatedAt", "createdAt"));
    out.tasks = mergeList(state.tasks, changes.tasks, (x) => x.id, (x) => at(x, "updatedAt", "createdAt"));
    out.mind = mergeList(state.mind, changes.mind, (x) => x.id, (x) => at(x, "updatedAt", "processedAt", "createdAt"));
    out.health = mergeList(state.health, changes.health, (x) => x.id, (x) => at(x, "loggedAt"));
    out.sessions = mergeList(state.sessions, changes.sessions, (x) => x.id, (x) => at(x, "completedAt", "abandonedAt", "startedAt"), { tombstones: false });
    out.habitLogs = mergeList(state.habitLogs, changes.habitLogs, (x) => `${x.habitId}|${x.localDate}`, (x) => at(x, "completedAt"), { tombstones: false });
    out.reviews = mergeList(state.reviews, changes.reviews, (x) => x.localDate, (x) => at(x, "createdAt"), { tombstones: false });
    // دفتر ستاره فقط اضافه می‌شود
    if (Array.isArray(changes.stars) && changes.stars.length) {
        const seen = new Set(state.stars.map((s) => s.id));
        const added = changes.stars.filter((s) => s?.id && !seen.has(s.id));
        if (added.length)
            out.stars = [...state.stars, ...added].sort((a, b) => a.createdAt - b.createdAt);
    }
    // مجموع ستاره‌ها همیشه از دفتر بازخوانی می‌شود — خودش را ترمیم می‌کند
    const total = out.stars.reduce((n, s) => n + s.delta, 0);
    out.progress = { ...out.progress, totalStars: total };
    return out;
}
//# sourceMappingURL=merge.js.map